import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { select,Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ApplicationState } from '../../../../store/application-store';
import { Profile } from '../../../../profiles/models/profile';
import { ClientProfile } from '../../../client-client-parent/models/client-profile';
import * as profileActions from '../../../../profiles/actions/profiles';
import * as profileSelectors from '../../../../profiles/selectors/profiles';
import * as clientclientParentSelectors from '../../selectors/client-client-parent';
import * as clientActions from '../../../../clients/actions/client-details';
import { ClientEditorComponent } from '../../components/client-editor/client-editor.component';
import { MojoWellKnownNames } from '../../../../common/constants/mojo-well-known-names';
import { ProfileService } from '../../../../profiles/services/profile.service';
import { ProductService } from '../../../../common/services/product.service';
import { takeWhile } from 'rxjs';

@Component({
  selector: 'mojo-client-admin-page',
  templateUrl: './client-admin-page.component.html',
})
export class ClientAdminPageComponent implements OnInit, OnDestroy {

  isAlive: boolean = true;
  pageTitle$: Observable<string>;
  dialogTitle: string;

  profiles$: Observable<Profile[]>;
  clientsProfiles$: Observable<ClientProfile[]>;
  clientLoading$: Observable<boolean>;
  profileLoading$: Observable<boolean>;

  @ViewChild(ClientEditorComponent, { static: true }) editor;

  constructor(
    protected store: Store<ApplicationState>,
    private profileService: ProfileService,
    private productService: ProductService) {
    this.store.dispatch(new profileActions.LoadAll(MojoWellKnownNames.Products.Mci));
    this.store.dispatch(new clientActions.Load());
    this.pageTitle$ = productService.currentProductTitle('Assign a profile to a Client', MojoWellKnownNames.Products.Mci);
  }

  ngOnInit() {
    this.profiles$ = this.profileService.getAllProfiles(MojoWellKnownNames.Products.Mci);
    this.clientsProfiles$ = this.store.pipe(select(clientclientParentSelectors.selectClientProfiles));
    this.clientLoading$ = this.store.pipe(select((state) => state.clientDetails.loading));
    this.profileLoading$ = this.store.pipe(select(profileSelectors.selectLoading()));
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  saveComplete(event: any) {
    this.store.dispatch(new profileActions.LoadAll(MojoWellKnownNames.Products.Mci));
    this.store.dispatch(new clientActions.Load());
  }

  clientSelected(event: any) {
    this.showEditDialog(event);
  }

  showEditDialog(selectedClient): void {
    this.dialogTitle = 'Client Properties';
    this.editor.showDialog(selectedClient);
  }
}
